import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { IconButton } from '@bibliocommons/base-buttons';
import { Info as InfoIcon } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import FormattedHTMLMessage from 'app/components/shared/FormattedHTMLMessage';
import { Modal, ModalContent, ModalFooter, ModalHeader } from 'app/components/shared/Modal';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';

const PromosInfoModal = ({ className, infoScreenReaderLabel }) => {
  const intl = useIntl();
  const currentLibrary = useSelector(selectCurrentLibrary);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeLabel = intl.formatMessage({ id: 'button_close' });
  const finalInfoScreenReaderLabel = infoScreenReaderLabel || intl.formatMessage({ id: 'about_this_content' });
  const modalTitleLabel = intl.formatMessage({ id: 'about_this_content' });
  const libraryName = currentLibrary.get('fullName');

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  return (
    <div className={className}>
      <IconButton dataKey="open-promos-info-button" handleClick={openModal}>
        <InfoIcon />
        <ScreenReaderMessage>{finalInfoScreenReaderLabel}</ScreenReaderMessage>
      </IconButton>
      <Modal handleClose={closeModal} key="promos-info-modal" open={isModalOpen}>
        <ModalHeader title={modalTitleLabel} />
        <ModalContent>
          <FormattedHTMLMessage id="content_cards_info" values={{ libraryName }} />
        </ModalContent>
        <ModalFooter
          handlePrimaryAction={closeModal}
          primaryActionButtonText={closeLabel}
          renderSecondaryAction={() => null}
        />
      </Modal>
    </div>
  );
};

PromosInfoModal.defaultProps = {
  className: '',
  infoScreenReaderLabel: ''
};

PromosInfoModal.propTypes = {
  className: PropTypes.string,
  infoScreenReaderLabel: PropTypes.string
};

export default PromosInfoModal;
